const data = {
  fastcompany: {
    logo:
      '//a.fastcompany.net/image/upload/v1488299125/fc/fastcompany-logo.svg',
    title: 'Fast Company',
    subscribeLink: 'https://www.fastcompany.com/combo',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [
      {
        url: '/premium',
        title: 'Premium'
      },
      {
        url: '/co-design',
        title: 'Co.Design'
      },
      {
        url: '/technology',
        title: 'Tech'
      },
      {
        url: '/work-life',
        title: 'Work Life'
      },
      {
        url: '/news',
        title: 'News'
      },
      {
        url: '/impact',
        title: 'Impact'
      },
      {
        url: '/podcasts',
        title: 'Podcasts',
        removeOnScale: true,
        external: true
      },
      {
        url: '/videos',
        title: 'Video'
      },
      {
        url: '/section/innovation-festival-360',
        title: 'Innovation Festival 360',
        mobileTitle: 'IF360'
      }
    ],
    channels: [
      {
        logo: '',
        title: 'FastCo Works',
        items: [
          {
            url: '/fcw/aws',
            title: 'AWS'
          },
          {
            url: '/fcw/genpact',
            title: 'Genpact'
          },
          {
            url: '/fcw/ibm',
            title: 'IBM'
          }
        ]
      }
    ]
  }
};

export default data;
